var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"text":""},on:{"click":function($event){$event.stopPropagation();return _vm.onRefresh.apply(null, arguments)}}},[_c('v-icon',{attrs:{"left":_vm.$vuetify.breakpoint.smAndUp}},[_vm._v("mdi-cached")]),_vm._v(" "),_c('div',{staticClass:"hidden-xs-only"},[_vm._v("Permisos")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }